import {Directive} from "@angular/core";

@Directive({
  selector: '[appFunctions]'
})
export class FunctionsDirective {

  constructor() {
    $(document).ready(function () {

      $('.dropdownToggle').click(function () {
        $('.dropdownCont').fadeToggle();
      });

      $(document).on('click', '.toggleBtn', function () {
        $(this).siblings(".toggleArea").slideToggle();
        if ($(this).text() == 'Hide detailed raiting') {
          $(this).text('Show detailed raiting');
        } else {
          $(this).text('Hide detailed raiting');
        }
      });

      $(document).on('click', '.toggleIntBtn', function () {
        $(this).siblings(".toggleItnArea").slideToggle();
      });

      $(document).on('click', '.toggleAllIntBtn', function () {
        if ($(this).text() == 'EXPAND ALL ITINERARY') {
          $(this).text('CLOSE ALL ITINERARY');
          $('.toggleItnArea').slideDown();
        } else {
          $(this).text('EXPAND ALL ITINERARY');
          $('.toggleItnArea').slideUp();
        }
      });

    });

  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/directives/functions.directive.ts